import React, { useCallback, useEffect, useState } from 'react';
import Registration from '~/App/shared/components/Auth/Registration';
import { SignIn } from '~/App/shared/components/Auth/SignIn/components/SignIn';
import ForgotPassword from '~/App/shared/components/ForgotPassword';

interface Props {
  setAuthInUse: (inUse: boolean) => void;
  setShouldKeepAuthMounted: (payload: boolean) => void;
}

const BiddingUserAuth = ({ setAuthInUse, setShouldKeepAuthMounted }: Props) => {
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
  const [isPasswordForgottenOpen, setIsPasswordForgottenOpen] = useState(false);

  const handlePressCreateAccount = useCallback(() => {
    setIsCreateAccountOpen(true);
    setShouldKeepAuthMounted(true);
  }, [setShouldKeepAuthMounted]);

  const handleOnPressForgotPassword = useCallback(() => {
    setIsPasswordForgottenOpen(true);
  }, []);

  const handleCreateAccountClose = useCallback(() => {
    setIsCreateAccountOpen(false);
    setShouldKeepAuthMounted(false);
  }, [setShouldKeepAuthMounted, setIsCreateAccountOpen]);

  useEffect(() => {
    setAuthInUse(isCreateAccountOpen || isPasswordForgottenOpen);
  }, [setAuthInUse, isCreateAccountOpen, isPasswordForgottenOpen]);

  useEffect(() => {
    return () => setAuthInUse(false);
  }, [setAuthInUse]);

  if (isCreateAccountOpen) {
    return <Registration onClose={handleCreateAccountClose} />;
  }

  if (isPasswordForgottenOpen) {
    return (
      <ForgotPassword
        isBiddingView
        handleClose={() => {
          setIsPasswordForgottenOpen(false);
        }}
      />
    );
  }

  return (
    <SignIn
      onPressCreateAccount={handlePressCreateAccount}
      onPressForgotPassword={handleOnPressForgotPassword}
      withNoTitle
    />
  );
};

export default BiddingUserAuth;
